import { Keyboard, X } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";

const SHORTCUTS = [
  { keys: ["N"], desc: "New task" },
  { keys: ["/"], desc: "Focus search" },
  { keys: ["D"], desc: "Toggle dark mode" },
  { keys: ["?"], desc: "Show this help" },
  { keys: ["1"], desc: "Switch to Board view" },
  { keys: ["2"], desc: "Switch to Dashboard" },
  { keys: ["3"], desc: "Switch to Calendar" },
  { keys: ["Esc"], desc: "Close modal / deselect" },
];

export const KeyboardShortcutsModal = ({ isOpen, onClose }) => (
  <Dialog open={isOpen} onOpenChange={onClose}>
    <DialogContent className="sm:max-w-sm">
      <DialogHeader>
        <DialogTitle className="flex items-center gap-2">
          <Keyboard className="h-5 w-5 text-primary" />Keyboard Shortcuts
        </DialogTitle>
      </DialogHeader>
      <div className="space-y-2">
        {SHORTCUTS.map((s, i) => (
          <div key={i} className="flex items-center justify-between py-1.5" data-testid={`shortcut-${i}`}>
            <span className="text-sm text-muted-foreground">{s.desc}</span>
            <div className="flex gap-1">
              {s.keys.map(k => (
                <kbd key={k} className="px-2 py-0.5 text-xs font-mono bg-muted border rounded-md">{k}</kbd>
              ))}
            </div>
          </div>
        ))}
      </div>
    </DialogContent>
  </Dialog>
);
